var exports = {
  "vK": "banner__Q467Ef",
  "u7": "logolink__cl6ut3",
  "Qg": "visuallyHidden__qrJvzL",
  "pq": "info__23t-kj",
  "yF": "divider__XZJxxs",
  "DD": "title__p98J3a",
  "nf": "link__ZS0QeK",
  "YE": "closeWrapper__VmRF-Q",
  "b": "closeButton__2B-u4Q",
};

module.exports = exports;
